import type { Asset } from '@schibsted-svp/svp-api-types';
import type { StreamProvider } from '@vgtv/api-client';

import { isHermesApp, isMobile } from '../../../utils/device';

export const getNativeAudioLink = (
  asset: Asset | undefined,
  fallbackProvider: StreamProvider
) => {
  if (!isHermesApp || !isMobile || !asset) {
    return undefined;
  }

  const vendor = asset.provider || fallbackProvider;

  if (!vendor) {
    return undefined;
  }

  return `audio:${vendor}:${asset.id}`;
};
